import React from 'react';

import {SkeletonItem, Stack} from '@edna/components/primitives';

import {Text} from 'src/components/primitives';

import * as S from './style';

type TBoardChipProps = {
  value?: React.ReactNode;
  title: string;
  hint?: string;
  icon: TSvgComponentType;
  color: TThemeColor;
  isLoading?: boolean;
};

export const BoardChip = React.memo<TBoardChipProps>(
  ({value = '-', title, hint, icon: Icon, color, isLoading}) => (
    <S.BoardChip>
      <S.BoardChipIcon color={color}>
        <Icon />
      </S.BoardChipIcon>
      <Stack size="2">
        <Text weight={600} size="XL">
          {isLoading ? <SkeletonItem width="100px" height="32px" /> : value}
        </Text>
        <Text size="S" secondary>
          {title}
          {!!hint && <S.InfoDropdown size="S" content={hint} hasMarginLeft />}
        </Text>
      </Stack>
    </S.BoardChip>
  ),
);

BoardChip.displayName = 'BoardChip';

type TAnalyticsBoardProps = {
  title: string;
  filters: React.ReactNode;
  children: React.ReactNode;
  isEmpty?: boolean;
};

export const AnalyticsBoard = React.memo<TAnalyticsBoardProps>(
  ({title, filters, children, isEmpty}) => (
    <S.Board>
      <S.BoardFilters>{filters}</S.BoardFilters>
      {!isEmpty && (
        <>
          <Text topIndent="6" secondary bottomIndent="2">
            {title}
          </Text>
          <S.BoardChips>{children}</S.BoardChips>
        </>
      )}
    </S.Board>
  ),
);

AnalyticsBoard.displayName = 'AnalyticsBoard';
